<template>
  <div>
    <!-- 渲染表格 -->
    <BasicTable searchPlaceholder="航线名称" :tableColumn="tableColumn" :tableData="tableData" :actions="actions"
                :showAddButton="uBtnPermissionList.includes('airline-add')" :showSearch="true" tableTitle="航线管理"
                :current="current" :total="total" :size="size" @add-item="addItem" @detail-item="detailItem" @edit-item="editItem"
                @delete-item="deleteItem" @search-item="searchItem" @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
      <template #customCol>
        <el-table-column prop="airpointList" label="包含航点" align="center" min-width="100" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ getAirpointNames(scope.row.airpointList) }}
          </template>
        </el-table-column>
        <el-table-column prop="isback" label="是否返航" align="center" min-width="30" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.isback == 0">否</span>
            <span v-if="scope.row.isback == 1">是</span>
          </template>
        </el-table-column>
        <el-table-column prop="airLineType" label="航线类型" align="center" min-width="50" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.airLineType == 0">观光</span>
            <span v-if="scope.row.airLineType == 1">巡检</span>
            <span v-if="scope.row.airLineType == 2">物流</span>
            <span v-if="scope.row.airLineType == 3">应急</span>
          </template>
        </el-table-column>
        <el-table-column prop="altitude" label="置信度" align="center" min-width="30" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-popover trigger="click" placement="left" width="900" v-if="scope.row.configdence" popper-class="confidence-popover">
              <div class="confidence-image-container">
                <div class="confidence-table-image">
                  <div class="table-header">
                    <div class="header-cell">影响因素</div>
                    <div class="header-cell">说明</div>
                    <div class="header-cell">权重</div>
                    <div class="header-cell">分值</div>
                    <div class="header-cell">描述</div>
                    <div class="header-cell">得分</div>
                  </div>
                  <div class="table-body">
                    <div v-for="(item, index) in formatTableData(scope.row.configdence)" :key="index" class="table-row">
                      <div class="body-cell">{{ item.name }}</div>
                      <div class="body-cell">{{ item.illustrate }}</div>
                      <div class="body-cell">{{ Math.floor(item.weight*100) }}%</div>
                      <div class="body-cell score-options">
                        <div v-for="scoreOption in getScoreOptions(item.key)" :key="scoreOption.score"
                             :class="['score-option', { 'score-selected': scoreOption.score == item.score }]">
                          {{ scoreOption.score }}
                        </div>
                      </div>
                      <div class="body-cell description-cell">
                        <div v-for="scoreOption in getScoreOptions(item.key)" :key="scoreOption.score"
                             :class="['description-option', { 'description-selected': scoreOption.score == item.score }]">
                          {{ scoreOption.description }}
                        </div>
                      </div>
                      <div class="body-cell score-result">{{ (item.weight * item.score) }}</div>
                    </div>
                  </div>
                  <div class="table-footer">
                    <div class="footer-cell">总得分</div>
                    <div class="footer-cell"></div>
                    <div class="footer-cell">100%</div>
                    <div class="footer-cell"></div>
                    <div class="footer-cell"></div>
                    <div class="footer-cell total-score">{{ getTotalScore(scope.row.configdence) }}</div>
                  </div>
                </div>
              </div>
              <div slot="reference" class="name-wrapper">
                {{ scope.row.configdence?JSON.parse(scope.row.configdence).weightedScore:'-' }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </template>
      <template #extraBtn="scope">
        <span>
          <el-button
            @click="computeConfidence(scope.row)" type="text" :disabled="isComputing" size="small">计算置信度
        </el-button>
        </span>
      </template>

    </BasicTable>
    <!-- 渲染弹框 -->
    <BasicForm labelWidth="100px" :dialogVisible="dialogVisible" :dialogTitle="dialogTitle" dialogType="航线"
               :formModel="taskForm" :btnName="btnName" @submit="handleFormSubmit" @update:dialogVisible="updateDialogVisible"
               :formRules="formRules">
      <div style="width: 100%; height: 100%; display: flex">
        <!-- 正常写本页面需要的表单项 -->
        <div style="width: 40%; height: 100%">
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="航线名称" prop="name">
                <el-input v-model="taskForm.name" :disabled="ifView" placeholder="请填写航线名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="海拔高(m)" prop="altitude" :rules="[
                {
                  required: true,
                  message: '请填写海拔高(m)',
                  trigger: 'blur',
                },
                { validator: this.validateNumber, trigger: 'blur' },
              ]">
                <el-input v-model="taskForm.altitude" :disabled="ifView" placeholder="请填写海拔高(m)"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="包含航点" prop="airpointlist" :rules="[
                {
                  required: this.canSelect,
                  trigger: 'blur',
                  message: '请选择包含的航点',
                },
              ]">
                <!--          <el-select-->
                <!--            v-model="taskForm.airpointlist"-->
                <!--            multiple-->
                <!--            :disabled="!canSelect"-->
                <!--            placeholder="请选择包含的航点"-->
                <!--            @change="changeAirPoint"-->
                <!--          >-->
                <!--            <el-option-->
                <!--              v-for="(landPoint, index) in landPoints"-->
                <!--              :key="index"-->
                <!--              :label="landPoint.name"-->
                <!--              :value="landPoint.id"-->
                <!--            ></el-option>-->
                <!--          </el-select>-->
                <el-select v-model="taskForm.airpointlist" placeholder="请选择包含的航点" @change="changeAirPoint"
                           :disabled="ifView" filterable remote multiple clearable reserve-keyword @focus="remoteSearchPoint('')"
                           :remote-method="remoteSearchPoint" :loading="pointLoading">
                  <el-option v-for="point in landPoints" :key="point.id" :label="point.name"
                             :value="point.id"></el-option>
                </el-select>
                <template>
                  <a v-show="dialogTitle != '新增'" class="aStyle" @click="toAirPoint">管理航点</a>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否返航" prop="isback">
                <el-select v-model="taskForm.isback" placeholder="请选择是否返航" popper-class="adminHomeSelect"
                           :disabled="ifView">
                  <el-option label="否" :value="0"></el-option>
                  <el-option label="是" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="航线类型" prop="airLineType">
                <el-select v-model="taskForm.airLineType" placeholder="请选择航线类型" popper-class="adminHomeSelect"
                           :disabled="ifView">
                  <el-option v-for="item in airLineTypes" :key="item.id" :label="item.name"
                             :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item class="select" label="省份" :rules="[
                { required: true, trigger: 'change', message: '请选择省份' },
              ]" prop="provinceCode">
                <el-select @change="handleProvinceChange" :disabled="ifView" v-model="taskForm.provinceCode"
                           placeholder="请选择省份">
                  <el-option v-for="province in provinces" :key="province.code" :label="province.name"
                             :value="province.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item class="alarmtime" label="城市" :rules="[
                { required: false, trigger: 'change', message: '请选择城市' },
              ]">
                <el-select clearable @change="handleCityChange" v-model="selectedCity" placeholder="请选择城市"
                           :disabled="!taskForm.provinceCode || ifView">
                  <el-option v-for="city in cities" :key="city.code" :label="city.name" :value="city.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item class="note" label="区/县" :rules="[
                { required: false, trigger: 'change', message: '请选择区域' },
              ]">
                <el-select v-model="selectedDistrict" placeholder="请选择区/县" clearable
                           :disabled="!selectedCity || ifView">
                  <el-option v-for="district in districts" :key="district.code" :label="district.name"
                             :value="district.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- todo 图片展示 -->
        <div style="width: 60%; height: 100%">
          <div class="tooptip" v-if="chooseLine">提示：双击结束绘制航线</div>
          <div style="
              width: 95%;
              height: 100%;
              margin-left: 20px;
              padding-top: 4px;
            ">
            <SecondMap style="width: 100%; height: 100%" showType="AirLine" :canDraw="canDraw"
                       :resetLineMap="dialogVisible" :airpointList="airpointList" @update-line="handleUpdateLine"
                       @choose-line="handleChooseLine"></SecondMap>
          </div>
        </div>
      </div>
    </BasicForm>
  </div>
</template>
<script type="text/javascript">
import BasicTable from "../../common/BasicTable.vue";
import BasicForm from "../../common/BasicForm.vue";
import SecondMap from "../../common/SecondMap.vue";
import axios from "axios";
export default {
  name: "AirLine",
  // 注入公共组件
  components: {
    BasicTable, //公共表格
    BasicForm, //公共弹框
    SecondMap, //公共地图
  },

  data() {
    return {
      isComputing: false,
      pointLoading: false,
      provinces: [],
      cities: [],
      districts: [],
      selectedCity: "",
      selectedDistrict: "",
      // ============表格配置信息==============
      // 列配置 label-列名，prop-对应列的字段名
      tableColumn: [
        //{ label: "航线编号", prop: "localId" },
        { label: "航线名称", prop: "name" },
        { label: "海拔高(m)", prop: "altitude" },
      ],
      tableData: [], // 列表内容数据
      landPoints: [], //航点数据
      actions: [],
      taskForm: {
        localId: "",
        name: "",
        altitude: "",
        airpointlist: [],
        provinceName: "",
        isback: 0, //默认否
        provinceCode:''
      }, // 表单数据绑定
      latlngs: [], //折线坐标
      chooseLine: false, //是否点击手绘按钮
      pointDataList: [], //航点信息
      showAddButton: true, //是否展示新增按钮
      dialogVisible: false,
      dialogTitle: "",
      btnName: "",
      ifView: false,
      // 定义表单必填校验
      formRules: [
        { label: "航线名称", prop: "name" },
        { label: "航线类型", prop: "airLineType" },
      ],
      canDraw: false, //用户是否可以绘制
      airpointList: [],
      canSelect: true, //是否可以下拉选择航点
      airLineTypes: [
        { id: 0, name: "观光" },
        { id: 1, name: "巡检" },
        { id: 2, name: "物流" },
        { id: 3, name: "应急" },
      ],
      configdenceEnu:{
        groundPersonnelSafety:{
          name: "地面人员安全",
          illustrate:'无人机坠地后，造成的人员伤害的概率，与人口密度和暴露程度成正比',
        },
        groundFacilitySafety:{
          name: "地面设施安全",
          illustrate:'无人机坠地后对城市设施造成损坏的概率，例如广播通信基站、电塔设施等',
        },
        searchDifficulty:{
          name: "搜寻难度",
          illustrate:'发生坠机事故后，对无人机及货物的回收难度',
        },
        secondaryDamage:{
          name: "次生伤害",
          illustrate:'发生坠机事故后，可能引发次生伤害的概率。例如电池燃烧引发火灾造成水体污染等事故。',
        },
        meteorologicalEnvironment:{
          name: "气象环境",
          illustrate:'航线区域发生特殊气象条件后，对运行造成影响。例如在江面不稳定的强气流，雾气等',
        },
        electromagneticEnvironment:{
          name: "电磁环境",
          illustrate:'运行中受到电磁干扰，例如 GPS信号干扰、操控链路干扰等',
        },
        obstacleEnvironment:{
          name: "障碍物环境",
          illustrate:'运行中遭遇临时性障碍物，具有不确定性。例如塔吊、正在建造的楼房等',
        },
        navigationAbilityRoute:{
          name: "导航能力（航线）",
          illustrate:'根据卫星导航性能，地面辅助导航性能进行综合定义。其中卫星导航性能是评估的主要依据，地面辅助导航性能可以作为卫星导航的补充',
        },
        navigationAbilityLandingPoint:{
          name: "导航能力（起降点）",
          illustrate:'起降点的导航性能，主要考虑是否使用视觉导航技术，卫星导航性能的影响',
        },
        communicationPerformance:{
          name: "通信性能",
          illustrate:'根据移动通信网络覆盖信号强度进行定义',
        },
        monitoringPerformance:{
          name: "监视性能",
          illustrate:'监视方式包括雷达，人工/计算机视觉，无线电侦听等手段',
        },
        publicAcceptability:{
          name: "公众可接受性",
          illustrate:'公众接受度父类',
        },
        privacyFactor:{
          name: "隐私因素",
          illustrate:'按照对隐私影响的可接受程度区分',
        },
        noiseFactor:{
          name: "噪声因素",
          illustrate:'按照对无人机产生的噪声的可接受程度进行区分',
        },
      },
      total: 0, //总条数
      current: 1, //当前页数
      size: 18, //显示几条
      searchKey: "", //搜索关键字
    };
  },
  watch: {
    chooseLine(newVal, oldVal) {
      console.log("new-->", newVal, "old-->", oldVal);
      if (newVal) {
        this.canSelect = false;
      } else {
        this.canSelect = true;
      }
    },
  },
  mounted() {
    this.getAllProvince();
    // 请求表格配置和数据
    this.$nextTick(function () {
      this.uBtnPermissionList.includes("airline-check") &&
      this.actions.push({ label: "查看", type: "view" });
      this.uBtnPermissionList.includes("airline-modify") &&
      this.actions.push({ label: "修改", type: "edit" });
      this.uBtnPermissionList.includes("airline-delete") &&
      this.actions.push({ label: "删除", type: "delete" });
      this.getAirLineData();
    });
  },
  computed: {
    uBtnPermissionList() {
      return this.getPageBtnRole("airLine") || [];
    },
  },
  methods: {
    formatTableData(data){
      if(data){
        const { weightedScore, ...restData } = JSON.parse(data);
        // 将剩余对象转换为对象数组
        const resultArray = Object.entries(restData).map(([key, value]) => ({
          name:this.configdenceEnu[key].name,//中文key
          key: key,           // 保留原始键名作为name属性
          illustrate: this.configdenceEnu[key].illustrate, // 描述
          score: value.score,  // 提取score属性
          weight: value.weight, // 提取weight属性
        }));
        return resultArray
      }else
        return []
    },
    // 获取所有分值选项
    getScoreOptions(key) {
      const allOptions = {
        groundPersonnelSafety: [
          { score: -1, description: '人口聚集或人员活动密集的区域,地面建筑物设施设备或树木难以对人员提供保护。如：道路、广场、体育场等' },
          { score: 1, description: '人口居住区或有人员活动非密集的区域，地面建筑物、设施设备或树木对人员提供一定保护。如：居住区、办公区等' },
          { score: 2, description: '人员活动较少的区域，地面建筑物、设施设备或树木对人员提供较强保护。如：荒地、河道绿化带等' }
        ],
        groundFacilitySafety: [
          { score: -1, description: '航线地面投影区域有较多、并且重要的城市基础设施。如：通信基站、铁塔等' },
          { score: 1, description: '航线地面投影区域有基础设施，但不易受到破坏。如：桥梁、道路等' },
          { score: 2, description: '无城市基础设施区域' }
        ],
        searchDifficulty: [
          { score: -1, description: '存在事故后无法收回的区域。如：江面、湖泊等' },
          { score: 1, description: '较难找寻的区域。如：小面积水域、林区、建筑密集区等' },
          { score: 2, description: '视野开阔，易搜索的区域' }
        ],
        secondaryDamage: [
          { score: -1, description: '能造成二次伤害区域。如:易发生火灾和水污染的区域等' },
          { score: 1, description: '可能造成二次伤害区域。如:加油站、湖泊、河流等区域' },
          { score: 2, description: '不易引发二次伤害的区域' }
        ],
        meteorologicalEnvironment: [
          { score: -1, description: '气象条件复杂，常出现特殊气象。如:建筑物风口丘陵山区等' },
          { score: 1, description: '气象条件比较复杂，容易发生特殊气象。如:宽阔工面、湖面，丘陵山区等' },
          { score: 2, description: '气象较稳定，不易出现特殊气象。如:开阔平坦区域等' }
        ],

        electromagneticEnvironment: [
          { score: -1, description: '电磁环境复杂区域。如:广播通信基站密集区域、超高压线附近等' },
          { score: 1, description: '电磁环境较复杂区域。如:铁塔周围、一般等级高压线周围等' },
          { score: 2, description: '电磁环境较单一区域' }
        ],

        obstacleEnvironment: [
          { score: -1, description: '障碍物环境复杂。如:正在施工的塔吊、正在建设的工地等' },
          { score: 1, description: '障碍物环境较复杂。如:风筝密集区等' },
          { score: 2, description: '无障碍物变化地区' }
        ],
        navigationAbilityRoute: [
          { score: -1, description: '接收到的卫星数量小于 8颗' },
          { score: 1, description: '1min 内有丢星现象，但获取卫星数大于8颗' },
          { score: 2, description: '具备地面辅助导航设备，且1min内稳定获取卫星数于 12 颗' }
        ],
        navigationAbilityLandingPoint: [
          { score: -1, description: '卫星信号测量结果无法稳定获取卫星信号，或1min内稳定获取卫星数小于 8 颗'},
          { score: 1, description: '卫星信号测量结果无法保持无人机利用卫星定位信号实现定点(1 min 内不超过2 m范围)悬停，或1 min 内稳定获取卫星数大于等于 8 颗且小于 12颗' },
          { score: 2, description: '无人机具备视觉导航能力，卫星信号测量结果可以保持无人机利用卫星定位信号,实现定点(1min 内不超过2m范围)悬停，或具备地面辅助导航设备' }
        ],
        communicationPerformance: [
          { score: -1, description: '单网移动通信3G/4G/5G信号强度覆盖大于-85dBm，且人口密度存在波动，易造成信号拥堵' },
          { score: 1, description: '至少双网移动通信3G/4G/5G信号强度覆盖大于-85dBm，且人口密度存在波动，易造成信号拥堵' },
          { score: 2, description: '至少双网移动通信3G/4G/5G信号强度大于-85dBm，且人口密度无波动，易造成信号拥堵' }
        ],
        monitoringPerformance: [
          { score: -1, description: '不具备监视能力' },
          { score: 1, description: '可识别合作目标' },
          { score: 2, description: '可识别合作目标和非合作目标' }
        ],
        privacyFactor: [
          { score: -1, description: '隐私保护需求强区域。如：政府单位等' },
          { score: 1, description: '隐私保护需求较强区域。如：别墅区等敞开式私人活动场所等' },
          { score: 2, description: '无隐私保护需求区域。如：公共场所等' }
        ],
        noiseFactor: [
          { score: -1, description: '噪音敏感区域。如：学校、疗养院、别墅区、社区等' },
          { score: 1, description: '噪音较敏感区域。如：办公区、医院自然公园等' },
          { score: 2, description: '噪音不敏感区域。如：公共区域等' }
        ]
      };

      return allOptions[key] || [];
    },
    // 获取分值对应的描述（保留原有方法以兼容）
    getScoreDescription(key, score) {
      const options = this.getScoreOptions(key);
      const option = options.find(opt => opt.score == score);
      return option ? option.description : '未定义';
    },
    // 计算总得分
    getTotalScore(data) {
      if (!data) return '0.00';
      try {
        const parsedData = JSON.parse(data);
        return parsedData.weightedScore ? parsedData.weightedScore.toFixed(2) : '0.00';
      } catch (e) {
        return '0.00';
      }
    },
    computeConfidence(item){
      this.isComputing = true
      this.postRequest(
        "/uav-task-server/cairline/calConfidence?id="+item.id
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.$message({
            message: oData.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          })
          this.getAirLineData()
        }else {
          this.$message({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function() {}
          });
        }
        this.isComputing = false
      })
    },
    remoteSearchPoint(query) {
      this.pointLoading = true;
      this.getWaypointData(query).then((res) => {
        this.landPoints = res;
      });
    },
    getAllProvince() {
      this.getRequest("/uav-task-server/region/getAllProvince").then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.provinces = oData.data;
        }
      });
    },
    handleProvinceChange(provinceCode) {
      // 清空市和区绑定的值
      this.selectedDistrict = "";
      this.selectedCity = "";
      this.getCitiesByProvince(provinceCode);
    },
    handleCityChange(cityCode) {
      // 清空区绑定的值
      this.selectedDistrict = "";
      this.getDistrictsByCity(cityCode);
    },
    getCitiesByProvince(provinceCode) {
      return this.getRequest(
        `/uav-task-server/region/getCity?provinceCode=${provinceCode}`
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.cities = oData.data;
        }
      });
    },
    getDistrictsByCity(cityCode) {
      return this.getRequest(
        `/uav-task-server/region/getDistrict?cityCode=${cityCode}`
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.districts = oData.data;
        }
      });
    },
    toAirPoint() {
      sessionStorage.setItem("selectMenuIndex", "airPoint");
      this.$emit("change-menu", "airPoint");
    },
    created() {
      this.selectedOptions = this.initialOptions; // 假设initialOptions是你从服务器获取的初始值
    },
    // 关闭对话框时获取子组件传过来的状态
    updateDialogVisible(newVal) {
      this.dialogVisible = newVal;
      this.resetForm();
      this.selectedCity = "";
      this.selectedDistrict = "";
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.getAirLineData();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.getAirLineData();
    },
    getWaypointData(query) {
      return this.getRequest(
        "/uav-task-server/cpoint/queryAllCPoint?pagesize=20&currentpage=1&keyword=" +
        query
      )
        .then((res) => {
          let oData = res.data;
          if (0 == oData.code) {
            this.pointLoading = false;
            let pointDataList = oData.data.list;
            pointDataList.forEach((pointData, index) => {
              switch (pointData.type) {
                case 0:
                  pointDataList[index].type = "普通航点";
                  break;
                case 1:
                  pointDataList[index].type = "临时起降点";
                  break;
                case 2:
                  pointDataList[index].type = "起降点";
                  break;
              }
            });
            return pointDataList;
          } else if (oData.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => { });
    },

    // 新增 打开弹框，如有下拉选项等数据可在此发请求加载

    getAirLineData() {
      this.getRequest(
        `/uav-task-server/cairline/queryAllCAirline?pagesize=${this.size}&currentpage=${this.current}&keyword=${this.searchKey}`
      )
        .then((res) => {
          console.log(res);
          let oData = res.data;
          if (0 == oData.code) {
            let pointData = oData.data;
            let pointDataList = pointData.list;
            if (pointDataList) {
              this.tableData = pointDataList;
              this.total = pointData.total;
              this.current = pointData.pageNum;
            } else {
              this.tableData = [];
            }
          }
        })
        .catch((error) => { });
    },
    //手绘航线时清除多选框航线
    handleUpdateLine(data) {
      this.taskForm.airpointlist = [];
      this.latlngs = data;
    },
    //选择或取消手绘航线按钮
    handleChooseLine(data) {
      this.chooseLine = data;
      console.log("chooseLine-->", data);
    },
    addItem() {
      this.dialogVisible = true;
      this.dialogTitle = "新增";
      this.btnName = "提交"; //如果是“提交”可不写该行
      this.ifView = false; //可编辑
      window.postMessage("clearPlane", "*");
      this.canDraw = true;
      this.canSelect = true; // 下拉可选
      this.chooseLine = false;
      this.resetForm();
      this.selectedCity = "";
      this.selectedDistrict = "";
    },
    // 重置表单
    resetForm() {
      this.taskForm = {
        localId: "",
        name: "",
        airpointlist: [], //多选应为数组
        provinceCode: "",
        provinceName: "",
        isback: 0, // 默认不返航
      };
    },
    // 查看
    detailItem(item) {
      this.getRequest(
        `/uav-task-server/cairline/queryCAirlineById?id=${item.id}`
      ).then((res) => {
        let oData = res.data;
        let data = oData.data;
        if (oData.code == 0) {
          this.selectedCity = data.cityName;
          this.selectedDistrict = data.regionName;
          this.dialogVisible = true;
          this.dialogTitle = "查看";
          this.btnName = "关闭";
          this.ifView = true; //仅查看，不可编辑
          this.taskForm = { ...data };
          this.landPoints = data.airpointList;
          this.airpointList = data.airpointList;
          this.canDraw = false;
          this.taskForm.airpointlist = data.airpointlist.split(",").map(Number);
        }
      });
    },
    // 修改
    editItem(item) {
      //通过id获取详情
      this.getRequest(
        `/uav-task-server/cairline/queryCAirlineById?id=${item.id}`
      ).then((res) => {
        let oData = res.data;
        let data = oData.data;
        if (oData.code == 0) {
          if (data.provinceName) {
            this.taskForm.provinceCode = data.provinceCode;
            this.getCitiesByProvince(data.provinceCode).then(() => {
              if (data.cityName) {
                this.selectedCity = data.cityCode;
                this.getDistrictsByCity(data.cityCode).then(
                  () => {
                    if (data.regionName){
                      this.selectedDistrict = data.regionCode;
                    }else{
                      this.selectedDistrict = ''
                    }
                    this.dialogVisible = true;
                  }
                );
              } else {
                this.selectedDistrict = ''
                this.selectedCity = ''
                this.dialogVisible = true;
              }
            });
          } else {
            this.selectedDistrict = ''
            this.selectedCity = ''
            this.taskForm.provinceCode =''
            this.dialogVisible = true;
          }
          this.dialogTitle = "修改";
          this.btnName = "提交"; //如果是“提交”可不写该行
          this.ifView = false; //可编辑
          this.taskForm = { ...data };
          this.landPoints = data.airpointList;
          this.airpointList = data.airpointList;
          this.canDraw = false;
          this.taskForm.airpointlist = data.airpointlist.split(",").map(Number);
          // this.getAirLineData();
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { },
          });
        }
      });
    },
    // 删除 TODO--
    deleteItem(itemId) {
      try {
        // 向API发送DELETE请求
        axios.get(`/uav-task-server/cairline/deleteById?id=${itemId}`).then(res=>{
          this.getAirLineData();

        })
      } catch (error) {
        console.error("删除失败", error);
      }
    },
    //监听修改航点展示航线
    changeAirPoint(value) {
      let selectedPoints = [];
      value.forEach((item) => {
        let point = this.landPoints.find((pointData) => pointData.id == item);
        selectedPoints.push(point);
      });
      this.airpointList = selectedPoints.filter((v) => v != undefined);
    },

    // 点击确认
    async handleFormSubmit(formData) {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      if (this.dialogTitle === "新增") {
        console.log(this.canDraw);
        if (!this.chooseLine) {
          // 执行新增操作 请求后端接口
          let params = {
            ...this.taskForm,
            regionCode: this.selectedDistrict
              ? this.selectedDistrict
              : this.selectedCity
                ? this.selectedCity
                : this.taskForm.provinceCode,
          };
          params.airpointlist = params.airpointlist.join(","); //传字符串给后端
          this.addLine(params);
        } else {
          // 执行新增操作 请求后端接口
          let pointArr = [];
          this.latlngs.forEach((item, index) => {
            let E = this.decimalToDMS(item[0]);
            let N = this.decimalToDMS(item[1]);
            pointArr.push({
              altitude: this.taskForm.altitude,
              latitude: item[1],
              longitude: item[0],
              name: `E${E}N${N}`,
              type: index == 0 || index == this.latlngs.length - 1 ? 1 : 0,
              regionCode: this.selectedDistrict
                ? this.selectedDistrict
                : this.selectedCity
                  ? this.selectedCity
                  : this.taskForm.provinceCode,
            });
          });
          let params = {
            name: this.taskForm.name,
            altitude: this.taskForm.altitude,
            airpointList: pointArr,
            isback: this.taskForm.isback,
            airLineType: this.taskForm.airLineType,
            regionCode: this.selectedDistrict
              ? this.selectedDistrict
              : this.selectedCity
                ? this.selectedCity
                : this.taskForm.provinceCode,
          };
          // 检查 手绘航线是否完成
          if (params.airpointList.length === 0) {
            // 如果为空，提示用户
            // alert("请完成航线绘制");
            this.$message.error("请完成航线绘制！");
          } else {
            // 如果不为空，调用接口进行信息新增
            this.saveCAirLineAndCAirPoint(params);
            this.selectedCity = "";
            this.selectedDistrict = "";
            this.taskForm.provinceCode = "";
          }
        }
      } else if (this.dialogTitle === "修改") {
        formData.airpointlist = formData.airpointlist.join(",");
        formData.regionCode = this.selectedDistrict
          ? this.selectedDistrict
          : this.selectedCity
            ? this.selectedCity
            : this.taskForm.provinceCode;
        const response = await axios.post(
          "/uav-task-server/cairline/updatecCAirline",
          formData,
          config
        );
        if (response.data.code == 0) {
          this.$message({
            message: response.data.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
          });
          this.dialogVisible = false;
          this.getAirLineData();
        } else {
          this.$message.error({
            message: response.data.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { },
          });
        }
      } else if (this.dialogTitle === "查看") {
        this.dialogVisible = false;
      }
      // this.dialogVisible = false;
      this.getAirLineData();
    },
    saveCAirLineAndCAirPoint(param) {
      this.postJsonRequest(
        "/uav-task-server/cairline/saveCAirLineAndCAirPoint",
        param
      ).then((res) => {
        let oData = res.data;
        if (oData.code == 0) {
          this.$message({
            message: oData.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () { },
          });
          this.getAirLineData();
          this.dialogVisible = false;
        } else {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () { },
          });
        }
      });
    },
    // 后端接口
    addLine(param) {
      this.postJsonRequest("/uav-task-server/cairline/addCAirline", param).then(
        (res) => {
          let oData = res.data;
          if (oData.code == 0) {
            this.$message({
              message: oData.msg,
              duration: 1000,
              customClass: "message-s",
              iconClass: "el-icon-ok-tip",
              offset: 470,
              onClose: function () { },
            });
            this.getAirLineData();
            this.dialogVisible = false;
            this.selectedCity = "";
            this.selectedDistrict = "";
            this.taskForm.provinceCode = "";
          } else if (oData.code != 401) {
            this.$message.error({
              message: oData.msg,
              duration: 1000,
              customClass: "message-warn-s",
              iconClass: "el-icon-warn-tip",
              offset: 470,
              onClose: function () { },
            });
          }
        }
      );
    },

    addPoints() {
      let pointArr = [];
      this.latlngs.forEach((item, index) => {
        let E = this.decimalToDMS(item[0]);
        let N = this.decimalToDMS(item[1]);
        pointArr.push({
          altitude: this.taskForm.autitude,
          latitude: item[1].toFixed(7).toString(),
          longitude: item[0].toFixed(7).toString(),
          name: `E${E}N${N}`,
          type: index == 0 || index == this.latlngs.length - 1 ? 1 : 0,
        });
      });
      this.postJsonRequest(
        "/uav-task-server/cpoint/addCPointList",
        pointArr
      ).then((res) => {
        let oData = res.data;
        console.log(res);
        // if (res.data) {
        //   this.$message({
        //     message: "提交成功",
        //     duration: 1000,
        //     customClass: "message-s",
        //     iconClass: "el-icon-ok-tip",
        //     offset: 470,
        //     onClose: function() {}
        //   });
        // } else if (oData.code != 401) {
        //   let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
        //   this.$confirm(tips, "提示", {
        //     confirmButtonText: "好的",
        //     customClass: "confirmClass-style",
        //     iconClass: "",
        //     confirmButtonClass: "confirm",
        //     dangerouslyUseHTMLString: true,
        //     showCancelButton: false
        //   });
        // }
      });
    },
    getAirpointNames(airpoints) {
      // 提取每个航点的name属性，并拼接
      return airpoints.map((point) => point.name).join(", ");
    },
    //经纬度转度分秒
    decimalToDMS(decimal) {
      const degrees = Math.floor(decimal);
      const minutes = Math.floor((decimal - degrees) * 60);
      const seconds = Math.floor(
        Math.round((decimal - degrees - minutes / 60) * 3600 * 1000) / 1000
      ); // 保留千分位
      return `${degrees}° ${minutes}' ${seconds}"`;
    },
    searchItem(val) {
      //模糊搜索
      // console.log(val);
      this.searchKey = val;
      this.getAirLineData();
    },
    // 数字校验 允许小数点
    validateNumber(rule, value, callback) {
      if (value === "" || !/^-?[1-9]\d*|0$/.test(value)) {
        callback(new Error("请填写有效的数字"));
      } else {
        callback();
      }
    },
  },
};
</script>
<style scoped>
.leaflet-draw {
  display: none !important;
}

>>>.el-dialog__header {
  /* background-image: url(../../img/common/tableHead.png); */
  /* background-position: 15px 13px;
    background-repeat: no-repeat;
    background-size: 300px 35px; */
  padding: 20px 20px 0px 40px;
  background: url(../../assets/img/2dmap/pop_bg.png) no-repeat;
  background-position: 18px 20px;
}

.tooptip {
  position: absolute;
  top: 49px;
  left: 751px;
  color: #ff4e4e;
  font-size: 14px;
}

.aStyle {
  color: #ffffff;
  cursor: pointer;
}

>>>.el-form .el-form-item {
  margin-bottom: 44px !important;
}

>>>.el-form {
  padding: 0 !important;
}

>>>.el-form-item__content {
  margin-left: 100px !important;
  height: 100%;
}

>>>#container .el-dialog__header {
  padding: 15px 20px 0px 40px !important;
}

>>>#container .el-dialog__headerbtn {
  top: 7px !important;
}
.name-wrapper {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}
>>> .blue-table-container {
  width: 100%;
  overflow-x: auto;
}

.confidence-image-container {
  width: 100%;
  background: #1a1a2e;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  border: 1px solid #2a2a3e;
}

.confidence-table-image {
  background: #16213e;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
  border: 1px solid #2a2a3e;
}

.table-header {
  display: flex;
  background: #0f3460;
  color: white;
  font-weight: bold;
  font-size: 12px;
  border-bottom: 1px solid #2a2a3e;
}

.header-cell {
  flex: 1;
  padding: 12px 8px;
  font-size: 14px;
  text-align: center;
  border-right: 1px solid #2a2a3e;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-cell:last-child {
  border-right: none;
}

.table-body {
  max-height: 400px;
  overflow-y: auto;
  background: #16213e;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #2a2a3e;
  transition: background-color 0.2s;
}

.table-row:hover {
  background-color: #1e2a4a;
}

.table-row:nth-child(even) {
  background-color: #1a1a2e;
}

.body-cell {
  flex: 1;
  padding: 10px 8px;
  text-align: center;
  font-size: 13px;
  border-right: 1px solid #2a2a3e;
  min-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  line-height: 1.3;
  color: #e8e8e8;
}

.body-cell:last-child {
  border-right: none;
}

.score-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 4px;
}

.score-option {
  height: 30px;
  width: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px;
  font-size: 10px;
  text-align: center;
  background-color: #2a2a3e;
  color: #b0b0b0;
  border: 1px solid #3a3a4e;
  cursor: default;
  transition: all 0.2s;
}

.score-option.score-selected {
  background-color: #409eff;
  color: white;
  border-color: #409eff;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.4);
}

.description-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 4px;
}

.description-option {
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 12px;
  text-align: left;
  background-color: #2a2a3e;
  color: #a0a0a0;
  border: 1px solid #3a3a4e;
  line-height: 1.2;
  transition: all 0.2s;
  min-height: 20px;
  display: flex;
  align-items: center;
}

.description-option.description-selected {
  background-color: #1e3a5f;
  color: #409eff;
  border-color: #409eff;
  font-weight: bold;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
}

.score-result {
  font-weight: bold;
  color: #67c23a;
  background-color: #1e3a1e;
  border-radius: 4px;
  margin: 2px;
  border: 1px solid #2a4a2a;
}

.table-footer {
  display: flex;
  background: #0f3460;
  color: white;
  font-weight: bold;
  font-size: 12px;
  border-top: 1px solid #2a2a3e;
}

.footer-cell {
  flex: 1;
  padding: 12px 8px;
  text-align: center;
  border-right: 1px solid #2a2a3e;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-cell:last-child {
  border-right: none;
}

.total-score {
  font-size: 14px;
  font-weight: bold;
  background-color: #409eff;
  color: white;
  border-radius: 4px;
  margin: 2px;
  padding: 4px 8px;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/home/AirLine.vue